// ISRC swarm-suggestion helpers
//
// Pure logic for the suggestion display + one-click accept on the ISRC review
// page. Kept in its own module (no React/context imports) so the accept path
// is unit-testable — a regression that dropped normalizeIsrc here would fail
// the acceptPayloadFor test rather than blowing up at click time.

function normalizeIsrc(s) {
  return (s || '').replace(/-/g, '').toUpperCase()
}

// Link to the source record backing a swarm suggestion, if we have an id.
function sourceUrl(source, sourceId) {
  if (!sourceId) return null
  if (source === 'deezer') return `https://www.deezer.com/track/${encodeURIComponent(sourceId)}`
  if (source === 'musicbrainz') return `https://musicbrainz.org/recording/${encodeURIComponent(sourceId)}`
  return null
}

// Payload accepting a swarm suggestion reuses the existing resolve endpoint:
// a manual_isrc resolution with an auto-generated note. No new endpoint needed.
function acceptPayloadFor(row) {
  return {
    song_f_id: row.song_f_id,
    artist_name: row.artist_name,
    track_title: row.track_title,
    resolution_kind: 'manual_isrc',
    manual_isrc: normalizeIsrc(row.proposed_isrc),
    notes: `accepted swarm suggestion (${row.proposal_source || 'unknown'}, ${row.proposal_confidence || 'unknown'})`,
  }
}

export { normalizeIsrc, sourceUrl, acceptPayloadFor }
